import BaseService from './baseService';
import cloneDeep from 'lodash/cloneDeep';
import {generateUrlQueryString} from '@/services/utilities';

class Products extends BaseService {
	async getProducts(page,opts = {}) {
    this.endPoint = '/products?jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getProductById(id,opts = {}) {
    this.endPoint = '/products/'+id;
		return this.get(opts);
  }
  async getProductByName(filter, opts= {}) {
    this.endPoint = `/product-by-name?q=${filter.q}`;
    return this.get(opts);
  }
	async getItems(opts = {}) {
    this.endPoint = '/items';
		return this.get(opts);
  }
  async getUserItems(page,opts = {}) {
    this.endPoint = '/items-user?jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
  async createProducts(payload){
    this.endPoint = '/products';
    return await this.post(payload); 
  }
  async bulkProduk(payload){
    this.endPoint = '/bulkProduk';
    return await this.post(payload); 
  }
  async updateProducts(id,payload,opts={}){
    this.endPoint = '/products';
    return await this.putOne(id,payload,opts);
  }
  async deleteProducts(id,opts={}){
    this.endPoint = '/products';
    return await this.delete(id,opts);
  }
  async getProductJasa(opts = {}) {
    this.endPoint = '/products-v2?'+generateUrlQueryString(opts);
		return this.get(opts);
  }
  async getScheduleByProductId(product_id, opts = {}) {
    this.endPoint = '/schedules.by_product_id/'+product_id;
		return this.get(opts);
  }
  async uploadImage(data,opts={}) {
    this.endPoint = 'uploadAttachmentProduct';
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return this.post(data, newOpts)
    // return await this.post(payload);
  }
  async removeImage(id,opts={}) {
    this.endPoint = 'deleteAttachmentProduct';
    return await this.delete(id,opts={});
  }
  async updateItems(id,payload,opts={}){
    this.endPoint = '/items';
    return await this.putOne(id,payload,opts);
  }
}

export default new Products();